import { initSentry } from "./lib/monitoring/sentry";
import { Toaster } from "./lib/toast";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import Routes from "./routes";
import ErrorBoundary from "./util-components/error/error-boundary";
import RootWrapper from "./util-components/root/root-wrapper";

// @slava - added an error handler
initSentry();
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <BrowserRouter>
    <RootWrapper>
      <ErrorBoundary>
        <Toaster richColors position="top-center" theme="light" toastOptions={{
          classNames: {
            toast: "border border-gray-200 shadow-lg",
            closeButton: "border border-gray-200 bg-white hover:bg-gray-50 text-gray-600 shadow-sm",
          }
        }}/>
        <Routes />
      </ErrorBoundary>
    </RootWrapper>
  </BrowserRouter>
);
